import { AssetType } from "@vviinn/user-managment-client-ts";

const fileTypeToAssetTypeMap: Record<string, AssetType> = {
  "text/css": "css",
  "image/svg+xml": "svg",
  "image/png": "png",
  "image/webp": "webp",
  "image/jpeg": "jpg",
  "text/csv": "csv",
};

export const fileTypeToAssetType = (fileType: string): AssetType => {
  return fileTypeToAssetTypeMap[fileType] || null;
};
